import * as R from 'ramda';
import { useSelector } from 'react-redux';

import routeTemplates from 'features/shared/utils/routeTemplates.js';
import sessionSelectors from 'features/shared/services/session/selectors.js';
import { getNextRouteConfig } from 'features/shared/services/router/selectors.js';
import { usePageStore } from 'features/counseling/signing/services/pageStore.js';

const getIdentity = R.prop('identity');

export function useNextRoute(routeSelector = getNextRouteConfig) {
  const identity = usePageStore(getIdentity);

  const nextRoute = useSelector(routeSelector);
  const routesFlow = useSelector(sessionSelectors.getRoutesFlowConfig);
  const authConfig = useSelector(sessionSelectors.getAuthConfig);

  if (
    R.prop('id', nextRoute) === routeTemplates.signing.id &&
    (!R.prop('isRequired', authConfig) || !R.isNil(identity))
  ) {
    const signingRouteFlow = R.find(R.propEq('id', routeTemplates.signing.id))(
      routesFlow
    );

    return R.isNil(signingRouteFlow) || R.isNil(signingRouteFlow.nextId)
      ? null
      : routeTemplates[signingRouteFlow.nextId];
  }

  return nextRoute;
}
